<template>
  <div class="py-4" v-if="initializing">
    <b-overlay :show="initializing">
    </b-overlay>
  </div>
  <b-container v-else fluid class="px-0">
    <b-row class="mb-3 justify-content-center">
      <b-col cols="12" lg="6" xl="3" md="6" class="mb-3 mb-xl-0">
        <b-input-group prepend="From Date">
          <b-form-datepicker
                  locale="en-US"
                  :date-format-options="{'year': 'numeric', 'month': 'long', 'day': 'numeric'}"
                  id="from-example-datepicker" :max="maxDateByToDate" @input="changeFromDate" v-model="filter.FromDate"></b-form-datepicker>
        </b-input-group>
      </b-col>
      <b-col cols="12" lg="6" xl="3" md="6">
        <b-input-group prepend="To Date">
          <b-form-datepicker
                  locale="en-US"
                  :date-format-options="{'year': 'numeric', 'month': 'long', 'day': 'numeric'}"
                  id="to-example-datepicker" :min="minDate" @input="changeToDate" v-model="filter.ToDate"></b-form-datepicker>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row v-if="!errorTextApi" class="justify-content-center">
      <b-col cols="12" class="mb-3">
        <div class="h3 mb-3 font-weight-bold text-center">
          Tip Summary
        </div>
        <div>
          <div v-if="filter.FromDate === filter.ToDate" class="text-center h5 font-weight-bold">
            For {{convertDate(filter.FromDate, 'noTime')}}
          </div>
          <div v-else class="text-center h5 font-weight-bold">
            For {{convertDate(filter.FromDate, 'noTime')}} - {{convertDate(filter.ToDate, 'noTime')}}
          </div>
          <div class="text-center" v-if="result.length">
            Created on {{convertDate(result[0].OrderDate)}}
          </div>
        </div>
      </b-col>
      <b-col cols="12" lg="6">
        <b-table-simple>
          <b-thead>
            <b-tr style="background-color: #bbbbbb">
              <b-th>Name</b-th>
              <b-th>Total Tip</b-th>
              <b-th>Card</b-th>
              <b-th>Cash</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr class="bg-white" v-for="item in result">
              <b-td>{{item.ServerName}}</b-td>
              <b-td>
                <currency-display :value="item.Tips"/>
              </b-td>
              <b-td>
                <currency-display :value="item.Tip_Card"/>
              </b-td>
              <b-td>
                <currency-display :value="item.Tip_Cash"/>
              </b-td>
            </b-tr>
            <b-tr class="bg-white">
              <b-td>Total</b-td>
              <b-td>
                <currency-display :value="totalTip()"/>
              </b-td>
              <b-td>
                <currency-display :value="totalCard()"/>
              </b-td>
              <b-td>
                <currency-display :value="totalCash()"/>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
      <b-col cols="12">
        <div class="small text-center">
          Note: Sales numbers are rounded to the nearest cent and may vary slightly from report to report.
        </div>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col>
        <div class="text-center h4 font-weight-bold text-danger">
          {{errorTextApi}}
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
    import moment from 'moment'
    import currencyDisplay from "../shared/currencyDisplay";
    export default {
        name: "serverShift",
        components: {
            currencyDisplay
        },
        data () {
            return {
                servers: [],
                selected: 'Receipt Printer',
                todayDate: moment().locale('en'),
                filter: {
                    ServerName: '',
                    ToDate: moment().locale('en'),
                    FromDate: moment().locale('en'),
                },
                type: "today",
                result: [],
                rowPrint: false,
                HasActiveReceiptPrinter: false,
                loadPrint: false,
                printers: [],
                printModal: false,
                serverIp: '',
                printMessage: {},
                loading: false,
                errorTextApi: '',
                initializing: true
            }
        },
        watch: {
            '$store.state.selectedRestaurantId': {
                handler: function (newVal) {
                    if (newVal) {
                        let object = {
                            RestaurantID: newVal,
                            // UserID: localStorage.getItem('userID'),
                        }
                        moment.locale('en');
                        object.FromDate = moment(this.filter.FromDate).locale('en').format('YYYY-MM-DD')
                        object.ToDate = moment(this.filter.ToDate).locale('en').format('YYYY-MM-DD')
                        this.getServers(object)
                    }
                },
                immediate: true
            }
        },

        mounted () {
            moment.locale('en');
        },
        computed: {
            maxDate () {
                const now = new Date()
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                const maxDate = new Date(today)
                return maxDate
            },
            maxDateByToDate () {
                const now = new Date(this.filter.ToDate)
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                const maxDate = new Date(today)
                return maxDate
            },
            minDate () {
              const now = new Date(this.filter.FromDate)
              const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
              const maxDate = new Date(today)
              return maxDate
            }
        },
        methods: {
            convertDate (date, noTime) {
                moment.locale('en');
                if (noTime) {
                    return date && moment(date).format('D MMM, YYYY')
                } else {
                    return date && moment(date).format('D MMM YYYY - hh:mm A')
                }
            },
            getServers (filter) {
                this.filter.ServerName = 'All'
                this.GetRestaurantShiftReport(this.filter)
                // this.loading = true
                // return this.$api.getRestaurant.GetRestaurantReportServer(filter).then(res => {
                //     this.loading = false
                //     if (res.success) {
                //         this.ServerName = ''
                //         res.RestaurantOrderServers.forEach(item => {
                //             item.fullName = item.ServerName
                //         })
                //         // const available = res.RestaurantClients.filter(i => i.Role.includes('Restaurant Server'))
                //         this.servers = [{fullName: 'All'}, ...res.RestaurantOrderServers]
                //         if (this.servers.length) {
                //             this.filter.ServerName = 'All'
                //             this.GetRestaurantShiftReport(this.filter)
                //         } else {
                //             this.result = []
                //             this.servers = []
                //         }
                //     }
                // }).catch(() => {
                //
                // })
            },
            changeServerName () {
                if (this.allFill()) {
                    this.GetRestaurantShiftReport(this.filter)
                }
            },
            GetRestaurantShiftReport (filter) {
                this.initializing = true
                moment.locale('en');
                filter.FromDate = moment(this.filter.FromDate).locale('en').format('YYYY-MM-DD')
                filter.ToDate = moment(this.filter.ToDate).locale('en').format('YYYY-MM-DD')
                filter.ServerName = this.filter.ServerName
                filter.RestaurantID = this.$store.state.selectedRestaurantId
                filter.UserID = localStorage.getItem('userID')
                filter.CombinationType = 'SumOfServers'
                return this.$api.getRestaurant.GetRestaurantShiftReport(filter).then(res => {
                    this.initializing = false
                    if (res.success) {
                        const findErr = res.OpenItems.find(item => item.errMsg)
                        if (findErr) {
                            this.result = []
                            this.errorTextApi = findErr.errMsg
                        } else {
                            this.result = res.OpenItems
                            this.errorTextApi = ''
                        }
                    } else {
                        this.$showError(res.message)
                        this.result = []
                        this.errorTextApi = 'No tab exists .....'
                    }
                }).catch(() => {

                })
            },

            allFill () {
                return this.filter.FromDate && this.filter.ToDate
            },
            changeFromDate () {
                if (this.allFill()) {
                    this.getServers(this.filter)
                }
            },
            changeToDate () {
                // this.filter.FromDate = ''
                if (this.allFill()) {
                    this.getServers(this.filter)
                }
            },

            changeDateMode (type) {
                this.type = type
                moment.locale('en');
                if (type === 'today') {
                    this.filter.FromDate = moment().locale('en').format('YYYY-MM-DD')
                    this.filter.ToDate = moment().locale('en').format('YYYY-MM-DD')
                    this.$nextTick(() => {
                        this.getServers(this.filter)
                    })
                } else {
                    this.filter.FromDate = moment().locale('en').subtract(1, 'days').format('YYYY-MM-DD')
                    this.filter.ToDate = moment().locale('en').subtract(1, 'days').format('YYYY-MM-DD')
                    this.$nextTick(() => {
                        this.getServers(this.filter)
                    })
                }
            },

            totalTip () {
                return this.result.reduce(function (acc, current) {
                    return Number(acc) + Number(current.Tips)
                }, 0);
            },
            totalCard () {
                return this.result.reduce(function (acc, current) {
                    return Number(acc) + Number(current.Tip_Card)
                }, 0);
            },
            totalCash () {
                return this.result.reduce(function (acc, current) {
                    return Number(acc) + Number(current.Tip_Cash)
                }, 0);
            }


        }
    }
</script>

